import _ from "lodash";
import app from "../lib/app";
import { POST_TO_IFRAME } from "constants/cart";

export interface MessageEvent<P extends object = any> {
    action: string;
    payload?: P;
}

export interface AnyMessage<E extends MessageEvent = MessageEvent> {
    action: string;
    event?: E;
}

export enum MessageTarget {
    Self,
    Parent,
    Top,
}

export const postToWindow = <M extends AnyMessage>(
    message: M | (() => M),
    target: MessageTarget = MessageTarget.Parent,
) => {
    let targetWindow: Window | undefined;
    switch (target) {
        case MessageTarget.Self:
            targetWindow = window;
            break;
        case MessageTarget.Top:
            // ATTENTION: could cause issues with Cypress tests. Use postToTopIframe instead
            targetWindow = window.top;
            break;
        default:
            const parent = window.parent;
            if (parent && parent !== window) {
                targetWindow = parent;
            }
            break;
    }

    if (targetWindow?.postMessage) {
        const resolvedMessage = _.isFunction(message) ? message() : message;
        targetWindow.postMessage(resolvedMessage, "*");
    }
};

export const postToTopIframe = (payload) =>
    postToWindow({
        action: "post-to-parent",
        payload,
    });

export const postToLegacyIframe = ({ action, payload }: { action: string; payload: any }) =>
    app.legacy.sendMessage({ action: action, payload });

export const postToShipmentReviewIframe = (data: { action: string; payload: any }) =>
    app.legacy.sendMessage({ action: POST_TO_IFRAME, data });
